import request from '@/utils/request'
import '@/utils/global.js'

export default {
  // 推荐列表
  getRecommendList(params) {
    return request({
      url: `rebuild/model/recommend/page`,
      method: 'get',
      params: params
    })
  },
  //官方推荐
  getRecommendNewList(params) {
    return request({
      url: `/rebuild/dataSet/page`,
      method: 'get',
      params: params
    })
  },
  getModelList(param) {
    return request({
      url: `rebuild/model/page`,
      method: 'get',
      params: param
    })
  },
  getDetail(param) {
    return request({
      url: `rebuild/model/` + param.mid + `/info`,
      method: 'get',
      params: param
    })
  },
  viewModel(param) {
    return request({
      url: `rebuild/model/` + param.mid + `/preview`,
      method: 'get',
      params: param
    })
  },
  getDownload(param) {
    return request({
      url: `rebuild/model/` + param.mid + `/download`,
      method: 'get',
      params: param
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/model.js